module.exports = __webpack_public_path__ + "media/images/illustrations/confetti-90cdf996b0af5381404880feaec1ee8a.svg";